import React from "react";
import People from "../../assets/img/icons/People.svg";
import Productivity from "../../assets/img/icons/Productivity.svg";
import Partners from "../../assets/img/icons/Partners.svg";
import Profit from "../../assets/img/icons/Profit.svg";
import Portfolio from "../../assets/img/icons/Portfolio.svg";
import Planet from "../../assets/img/icons/Planet.svg";
 

const CompanyIcons = () => {
  return (
    <section className="pricing-wrapper section-padding pricing-bg">
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-8 offset-lg-2">
            <div className="block-contents text-center">
              <div className="section-title">
                <h2>Our Premium Features</h2>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-4 col-md-6 col-12">
            <div className="single-pricing-plan">
              <div className="package-head">
                <div className="icon">
                  <img src={People} alt="" />
                </div>
                <div className="package-title">
                  <h6>People:</h6>
                  {/* <h2>$49.00</h2> */}
                </div>
              </div>
              <div className="package-features">
                <span>
                  Be a great place to work where people are inspired to be the
                  best they can be.
                </span>
              </div>
              {/* <div className="package-btn">
                <Link to="/contact">Choose Plan</Link>
              </div> */}
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-12">
            <div className="single-pricing-plan" style={{
              paddingBottom:"80px"
            }}>
              <div className="package-head">
                <div className="icon">
                  <img src={Productivity} alt="" />
                </div>
                <div className="package-title">
                  <h6>Productivity :</h6>
                  {/* <h2>$89.00</h2> */}
                </div>
              </div>
              <div className="package-features">
                <span>
                  Be a highly effective, lean and fast-moving organization.
                </span>
              </div>
              {/* <div className="package-btn">
                <Link to="/contact">Choose Plan</Link>
              </div> */}
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-12">
            <div className="single-pricing-plan  ">
              <div className="package-head">
                <div className="icon">
                  <img src={Partners} alt="" />
                </div>
                <div className="package-title">
                  <h6>Partners :</h6>
                  {/* <h2>$69.00</h2> */}
                </div>
              </div>
              <div className="package-features">
                <span>
                  Be a great place to work where people are inspired to be the
                  best they can be.
                </span>
              </div>
              {/* <div className="package-btn">
                <Link to="/contact">Choose Plan</Link>
              </div> */}
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-12">
            <div className="single-pricing-plan">
              <div className="package-head">
                <div className="icon">
                  <img src={Planet} alt="" />
                </div>
                <div className="package-title">
                  <h6>Planet :</h6>
                  {/* <h2>$89.00</h2> */}
                </div>
              </div>
              <div className="package-features">
                <span>
                  Be a responsible citizen that makes a difference by helping
                  build and support sustainable communities.
                </span>
              </div>
              {/* <div className="package-btn">
                <Link to="/contact">Choose Plan</Link>
              </div> */}
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-12">
            <div className="single-pricing-plan">
              <div className="package-head">
                <div className="icon">
                  <img src={Profit} alt="" />
                </div>
                <div className="package-title">
                  <h6>Profit :</h6>
                  {/* <h2>$89.00</h2> */}
                </div>
              </div>
              <div className="package-features">
                <span>
                  Maximize long-term return to shareowners while being mindful
                  of our overall responsibilities.
                </span>
              </div>
              {/* <div className="package-btn">
                <Link to="/contact">Choose Plan</Link>
              </div> */}
            </div>
          </div>
         
          <div className="col-lg-4 col-md-6 col-12">
            <div className="single-pricing-plan">
              <div className="package-head">
                <div className="icon">
                  <img src={Portfolio} alt="" />
                </div>
                <div className="package-title">
                  <h6>Portfolio :</h6>
                </div>
              </div>
              <div className="package-features">
                <span>
                  Bring to the world a portfolio of quality cotton that
                  anticipate and satisfy people's desires and needs.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyIcons;
